import React from 'react';
import { Modal, Form, Input, Button, Row, Col, TreeSelect } from 'antd-v5';
const SpuFormModal = (props) => {
  const { title, treeData, visible, onCancel, onSave, rows } = props;
  return (
    <Modal
      title={title}
      visible={visible}
      onCancel={onCancel}
      destroyOnClose
      width='600px'
      className='commodity-modal'
      footer={null}
    >
      <Form
        style={{ marginTop: 36 }}
        onFinish={onSave}
        initialValues={{
          name: rows.name,
          categoryId: rows.categoryId,
        }}
      >
        <Form.Item
          label='货品'
          name='name'
          rules={[
            { required: true, message: '请输入货品' },
            { type: 'string', min: 1, max: 20, message: '货品不超过20位' },
          ]}
        >
          <Input placeholder='请输入货品' allowClear />
        </Form.Item>
        <Form.Item
          label='货品分类'
          name='categoryId'
          rules={[{ required: true, message: '请选择货品分类' }]}
        >
          <TreeSelect
            placeholder='请选择货品分类'
            treeLine
            treeDefaultExpandAll
            allowClear
            showSearch
            treeData={treeData}
            filterTreeNode={(input, treeNode) => {
              return treeNode.props.title.indexOf(input) >= 0;
            }}
          />
        </Form.Item>
        <Form.Item>
          <Row gutter={10} style={{ textAlign: 'center' }}>
            <Col span={24}>
              <Button type='primary' htmlType='submit' style={{ width: 80 }}>
                保存
              </Button>
              <Button style={{ marginLeft: 25, width: 80 }} onClick={onCancel}>
                取消
              </Button>
            </Col>
          </Row>
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default SpuFormModal;
